export const environment = {
  production: true
};
export const LADAAT_SERVER="https://ladaat-tora.com/api/"
